import { getNumericValue, resolveFallback } from "./formatterUtils";

type FormatCurrencyOptions = {
  fallback?: string;
  showFallback?: boolean;
  showZeros?: boolean;
  symbol?: boolean;
};

const CURRENCY_PRECISION = 2;

export function formatCurrency(value?: number | string | null, options: FormatCurrencyOptions = {}): string {
  const { fallback = "--", showFallback = true, showZeros = false, symbol = true } = options;

  const numericValue = getNumericValue(value);
  if (numericValue === null) {
    return resolveFallback({
      fallback,
      showFallback,
      showZeros,
      zeroValue: symbol ? `AED ${Number(0).toFixed(CURRENCY_PRECISION)}` : `${Number(0).toFixed(CURRENCY_PRECISION)}`,
    });
  }

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: CURRENCY_PRECISION,
    maximumFractionDigits: CURRENCY_PRECISION,
  });

  const formattedNumber = formatter.format(Math.abs(numericValue));
  const sign = numericValue < 0 ? "-" : "";

  return symbol ? `AED ${sign}${formattedNumber}` : `${formattedNumber}`;
}
